import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Nav, Tab } from "react-bootstrap";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserFileTab from "../user/UserFileTab";
import GroupFileTab from "../group/GroupFileTab";
import AdminDashboardCharts from "./AdminDashboardCharts";
import AdminDashboardCards from "./AdminDashboardCards";
import DateRangeSelector from "../filterDataRange/DateRangeSelector";
import { BackIcon, CrownIcon, SpinnerIcon } from "../../../assets/icons/iconshere";
import TeamDashbordLoad from "../../ContentLoader/teamdashboardload";
import { FaArrowLeftLong } from "react-icons/fa6";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { exportMultipleChartsToPdf, generateExcel } from "../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../SvgIconsData";
import ProPopup from "../../layouts/ProPopup";

import moment from "moment";

const AdminDashboard = () => {
  var location = useLocation();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const navigate = useNavigate();
  if (!location?.state?.uuid) navigate(`/team-dashboard/${userData.user.group.uuid}`, { state: userData.user.group });
  const [filter, setFilter] = useState("all");
  const [dashboardAnalytics, setDashboardAnalytics] = useState({
    modules: []
  });
  const [chartAnalytics, setChartAnalytics] = useState({});
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [search, setSearch] = useState("");
  const params = useParams();
  const { groupId } = params;
  const [loadingTeam, setLoadingTeam] = useState(true);
  const [loadingChart, setLoadingChart] = useState(true);
  const [roleList, setRoleList] = useState([]);
  const [groupTypesList, setGroupTypesList] = useState([]);
  const [groupLength, setGroupLength] = useState(0)
  const [userLength, setUserLength] = useState("")
  const [openPro, setOpenPro] = useState(false);
  const [pdfSpinner, setPdfSpinner] = useState(false);
  const [excelSpinner, setExcelSpinner] = useState(false);
  const [userPlan, setUserPlan] = useState(null);

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  const arr = [];
  const { modules } = dashboardAnalytics;
  modules.sort((a, b) => { return b.certificates - a.certificates });
  modules.map((e, i) => { arr.push([e.name, e.certificates]) });

  const userGroupTypeId = userData?.user?.group?.typeId || null;

  const onGroupSelect = (group) => {
    navigate(`/team-dashboard/${group.uuid}`, { state: group });
  };

  const onUserSelect = (user) => {
    navigate(`/team/user/${user.uuid}`, { state: user });
  };

  const getTeamDashboardAnalytics = async () => {
    try {
      let { data } = await axios.get(
        `${configData.config.API_URL}/api/dashboard/group/${configData.config.MODE}/${groupId}`,
        {
          params: {
            filter: filter,
            applicationId: configData.config.applicationId
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setDashboardAnalytics({ ...data });
    } catch (error) {
      console.log(error);
    }
    setLoadingTeam(false);
  };

  const getChartAnalytics = async () => {
    setChartAnalytics({});
    try {
      let { data } = await axios.get(
        `${configData.config.API_URL}/api/dashboard/group/charts/${configData.config.MODE}/${groupId}`,
        {
          params: {
            filter: filter,
            applicationId: configData.config.applicationId
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setChartAnalytics({ ...data });
    } catch (error) {
      console.log(error);
    }
    setLoadingChart(false);
  };

  const geRoleTypesList = async () => {
    try {
      let { data } = await axios.get(
        `${configData.config.UNO_URL}/api/role/list/PRIVATE/${userGroupTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setRoleList(data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const geGroupTypeList = async () => {
    try {
      let { data } = await axios.get(`${configData.config.UNO_URL}/api/role/grouptype/list`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      setGroupTypesList(data?.data?.groupTypes || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userGroupTypeId) {
      geRoleTypesList();
      geGroupTypeList();
    }
  }, [userGroupTypeId]);

  useEffect(() => {
    setLoadingChart(true);
    setLoadingTeam(true);
  }, [groupId]);

  useEffect(() => {
    setActiveTab("Dashboard");
    // getTeamDashboardAnalytics();
    // getChartAnalytics();
    Promise.all([getTeamDashboardAnalytics(), getChartAnalytics()])
  }, [filter, groupId]);

  const tableData1 = [
    ["Team Dashboard", ""],
    ["Team Name", location?.state?.name],
    ["Report Generated at", moment().format("lll")],
    ["Date Range", `${moment(chartAnalytics?.start).format('D/M/YYYY')}-${moment(chartAnalytics?.end).format('D/M/YYYY')}`],
    ["Total Trainings", chartAnalytics?.counts?.total?.all ?? 0],
    ["Guided Trainings", chartAnalytics?.counts?.total?.guided ?? 0],
    ["Unguided Trainings", chartAnalytics?.counts?.total?.unguided ?? 0],
    ["Total Registered Users", chartAnalytics?.users?.total?.total ?? 0],
    ["Active Users", chartAnalytics?.users?.total?.active ?? 0],
    ["Inactive Users", chartAnalytics?.users?.total?.inactive ?? 0],
    ["Time Spent - Total ", chartAnalytics?.duration?.total?.all?.sum?.humanReadable ?? 0],
    ["Time Spent - Guided", chartAnalytics?.duration?.total?.guided?.sum?.humanReadable ?? 0],
    ["Time Spent - Unguided", chartAnalytics?.duration?.total?.unguided?.sum?.humanReadable ?? 0],
  ];


  const tableData2 = [["Courses", "No.of Certified Users"], ...arr];

  // if (loadingTeam && loadingChart) return <TeamDashbordLoad />;

  const handleClickPdfDownload = async (name, table1, table2) => {
    setPdfSpinner(true);
    await exportMultipleChartsToPdf(name, table1, table2)
    setPdfSpinner(false);
  }

  const handleClickExcelDownload = async (name, table1, table2) => {
    setExcelSpinner(true);
    await generateExcel(name, table1, table2)
    setExcelSpinner(false);
  }

  return (
    <>
      <div className="container-fluid p-0">
        <div className="col-md-12">
          <Tab.Container id="my-tabs" activeKey={activeTab} defaultActiveKey="Dashboard">
            <div className="col-md-12">
              <Nav className="tabsproduct updated toptab" variant="tabs">
                <Nav.Item>
                  <Nav.Link onClick={() => setActiveTab("Dashboard")} eventKey="Dashboard">
                    Dashboard
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link onClick={() => userPlan?.teamDashboard?.group ? setActiveTab("Groups") : setOpenPro(true)} eventKey="Groups">
                    Groups {!loadingTeam && <span> ({groupLength}) </span>}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link onClick={() => userPlan?.teamDashboard?.user ? setActiveTab("Users") : setOpenPro(true)} eventKey="Users">
                    Users    {!loadingTeam && <span> ({userLength}) </span>}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>

            <div className="container-fluid admindashboard pt-0 bg-grey-main">
              <Tab.Content className="pt-3 ">
                <Tab.Pane eventKey="Dashboard">
                  <div className="row">
                    <div className="bg-grey-main dashboard p-3 px-0">
                      <div className="container-fluid">
                        <div className="row py-2 mt-3 pb-2">
                          <div className="col-md-6 d-flex align-items-center">
                            {groupId !== userData.user.group.uuid && (
                              <button
                                className="backbtn cursor-pointer ps-2 mt-2"
                                title="Back"
                                onClick={() => navigate(-1)}>
                                <BackIcon /> Back
                              </button>
                            )}
                          </div>
                          <div className="col-md-6 d-flex gap-2 align-items-center" >
                            <DateRangeSelector selected={filter} setSelected={setFilter} />

                            {userPlan && userPlan?.teamDashboard?.download ?
                              <>
                                <button
                                  className="DefaultRedBtn download px-2"
                                  title="Download PDF"
                                  onClick={() => handleClickPdfDownload("Team_Dashboard", tableData1, tableData2)}>
                                  {pdfSpinner ? <SpinnerIcon /> : <PDFDownloadIcon />}
                                </button>

                                <button
                                  className="DefaultRedBtn download px-2"
                                  title="Download Excel"
                                  onClick={() => handleClickExcelDownload("Team_Dashboard", tableData1, tableData2)}>
                                  {excelSpinner ? <SpinnerIcon /> : <EXLDownloadIcon />}
                                </button>
                              </>
                              :
                              <button className="DefaultRedBtn pro" onClick={() => setOpenPro(true)}>
                                <CrownIcon />
                                <p> Download Reports </p>
                              </button>}


                          </div>
                        </div>
                        <div className="row pt-2">
                          <AdminDashboardCards
                            loadingTeam={loadingTeam}
                            group={location.state}
                            dashboardAnalytics={dashboardAnalytics}
                          />
                        </div>
                        <AdminDashboardCharts
                          chartAnalytics={chartAnalytics}
                          analytics={dashboardAnalytics}
                          filter={filter}
                          groupId={groupId}
                          group={location.state}
                          loadingChart={loadingChart}
                        />
                      </div>
                    </div>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="Groups">
                  <GroupFileTab
                    groupTypesList={groupTypesList}
                    setSearch={setSearch}
                    search={search}
                    onSelect={(group) => onGroupSelect(group)}
                    setGroupLength={setGroupLength}
                  />
                </Tab.Pane>

                <Tab.Pane eventKey="Users">
                  <UserFileTab
                    roleList={roleList}
                    setSearch={setSearch}
                    search={search}
                    onSelect={(user) => onUserSelect(user)}
                    userLength={userLength}
                    setUserLength={setUserLength}
                  />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>

      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>

  );
};

export default AdminDashboard;
